const CUSTOMER_ID = '120361943'
const API_KEY = 'wPiBzV4EXosTnLIeoVdFOg'

export default async function verificarDominio({ dominio, resultado, carregando }) {


  if (!dominio.value) {
    resultado.value = 'Digite um domínio para verificar.'
    return
  }

  carregando.value = true
  resultado.value = ''

  try {
    const res = await fetch(
      `https://jsonwhoisapi.com/api/v1/whois?identifier=${encodeURIComponent(dominio.value)}`,
      {
        method: 'GET',
        headers: {
          Authorization: 'Basic ' + btoa(`${CUSTOMER_ID}:${API_KEY}`)
        }
      }
    )

    const data = await res.json()

    if (data.registered === false) {
      resultado.value = `✅ O domínio ${data.name} está disponível para registro (valor do registro não incluso no plano).`
    } else {
      resultado.value = `❌ O domínio ${data.name} já está registrado, escolha outro nome.`
    }

  } catch (err) {
    console.error(err)
    resultado.value = 'Erro ao verificar domínio. Verifique o nome ou tente novamente.'
  } finally {
    carregando.value = false
  }
}
